import IJobSection from "../../interfaces/IJobSection";
import { BoxHeader } from "./box-header";
import * as React from "react";
import { useState } from "react";
import Icons from "../Icons";
import { BoxHeaderOption } from "./box-header-option";
import InhibitorPaginatedColumnChart from "../inhibitor-chart/InhibitorPaginatedColumnChart";
import { Section } from "./section";
import { VinaJobCheckedContainer } from "./vina-job-checked-container";

export function SectionInhibitorChart({section}: {section: IJobSection}) {

  const [inhibitorChartOnlyAssociatedDrugs, setInhibitorChartOnlyAssociatedDrugs] = useState(false);
  
  return (
    <Section section={section} className="ll-break-inside-avoid" style={{marginTop: '1rem'}}>
      <BoxHeader section={section}>
        <BoxHeaderOption
          title={<>only associated drugs {Icons.associatedDrug}</>}
          checked={inhibitorChartOnlyAssociatedDrugs}
          setChecked={setInhibitorChartOnlyAssociatedDrugs}
        />
      </BoxHeader>
      <div className="ll-section-body">
        <VinaJobCheckedContainer>
          <InhibitorPaginatedColumnChart
            onlyAssociatedDrugs={inhibitorChartOnlyAssociatedDrugs}
          />
        </VinaJobCheckedContainer>
      </div>
    </Section>
  )
}